import ProfilePublications from './ProfilePublications.component';

export default ProfilePublications;